import { ECustomFieldType } from '@/utils/enums'
import { GhgEmissionCalculationMaterial } from '@/utils/ghgEmission/GhgEmissionCalculationMaterial'
import { IListStringItem } from '..'

export interface ICustomFieldData {
  order?: number
  label?: string
  fieldType: ECustomFieldType
  text?: string
  number?: number
  eSign?: string
  date?: string
  dateTimeData?: string
  email?: string
  phoneNumber?: IPhoneNumberCustomFieldData
  multiSelect?: ISelectionItem[]
  singleSelect?: ISelectionItem
  files?: IFile[]
  reference?: IReferenceCustomFieldData
  ghgEmission?: GhgEmissionCustomField
  calculation?: string
  adjustment?: number
  currentValue?: number
  weightMeasurement?: IWeightMeasurement
  listString?: IListStringItem[]
}

export interface ICalculation {
  fieldType: ECustomFieldType.CALCULATION
  [ECustomFieldType.CALCULATION]: string
}

export interface IPhoneNumberCustomFieldData {
  number: string
  countryCode: string
}

export interface IFile {
  uid?: string
  path?: string
  url?: string
  name?: string
  response?: string
  label?: string
  status?: string
}

export interface ISelectionItem {
  key: string
  value: string
}

export interface GhgEmissionCustomField {
  fieldType: ECustomFieldType.GHG_EMISSION
  [ECustomFieldType.GHG_EMISSION]: number
  material: GhgEmissionCalculationMaterial
}

export interface IReferenceData {
  template: string
  url: string
  text: string
}

export interface IReferenceCustomFieldData {
  url: string
  file: IFile
  text: string
  label: string
  template: string
}

export interface IWeightMeasurement {
  lastMeasurementAt: string
  lastWeight: number
  measurementHistory: IWeightMeasurementHistoryItem[]
  hasFailedFetchingMeasurement: boolean
}

export interface IWeightMeasurementHistoryItem {
  current: number
  measuredAt: string
  pushedMeasureButton: boolean
}
